<template>
  <div v-if="visible && message" class="error-bar">
    <span class="error-text">{{ message }}</span>
  </div>
  <div v-else></div>
  <!-- keep root stable -->
</template>

<script setup lang="ts">
interface Props {
  message: string
  visible?: boolean
}

withDefaults(defineProps<Props>(), {
  message: "",
  visible: true
});
</script>

<style scoped>
.error-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: #b00020; /* material error */
  color: #ffffff;
  padding: 8px 12px;
  text-align: center;
  font-weight: 600;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.error-text {
  display: inline-block;
  line-height: 1.2;
}
</style>




